import { useState } from 'react';

import dynamic from 'next/dynamic';

import ItemDetailPage from '@/components/detailPage/itemDetailPage';
import NavList from '@/components/navList';

const DynamicItemRightPage = dynamic(() => import('@/components/detailPage/itemRightPage'));
const DynamicItemRightInquiry = dynamic(() => import('@/components/detailPage/itemRightInquiry'));
const DynamicProductRecommend = dynamic(() => import('./components/productRecommend'));
const DynamicItemTab = dynamic(() => import('./itemTab'));

export default function DetailPage({ webData, similarProductRecommend, productPdfDesc }) {
  const [productRecommendMounted, setProductRecommendMounted] = useState(false);

  return (
    <div className="pb-[40px]">
      <NavList data={webData} />
      <div className="mt-[15px] mx-auto flex items-start w-[1200px] min-h-[600px]">
        <ItemDetailPage
          data={webData}
          productRecommendMounted={productRecommendMounted}
          productPdfDesc={productPdfDesc}
        />
        {/* 商品已下架 */}
        {webData?.productRecord?.isDisplay === false ? (
          <DynamicItemRightInquiry data={webData} />
        ) : (
          <DynamicItemRightPage data={webData} />
        )}
      </div>
      {!webData?.isOversea && (
        <DynamicProductRecommend data={webData} setProductRecommendMounted={setProductRecommendMounted} />
      )}
      {(similarProductRecommend?.similarProductList?.length || similarProductRecommend?.otherProductList?.length) && (
        <DynamicItemTab itemTabList={similarProductRecommend} />
      )}
    </div>
  );
}
